import * as React from "react";
import { Wrench, ShieldAlert } from "lucide-react";

import { cn } from "@/lib/utils";
import { useStore } from "@/context/StoreContext";

export const MaintenanceGate = ({ children }) => {
  const { settings } = useStore();

  const enabled = Boolean(settings?.maintenanceMode);
  if (!enabled) return children;

  const msg = String(settings?.maintenanceMessage || "").trim();

  return (
    <div
      className={cn(
        "min-h-[70vh] flex items-center justify-center",
        "rounded-xl sm:rounded-2xl",
        "border border-border/60 bg-card/30 backdrop-blur",
        "p-6 sm:p-10"
      )}
    >
      <div className="max-w-2xl text-center">
        <div className="mx-auto mb-5 grid size-16 place-items-center rounded-3xl bg-yellow-500/15 border border-yellow-500/25">
          <Wrench className="size-8 text-yellow-500" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">
          Site şu anda bakım modunda
        </h1>
        <p className="mt-2 text-sm sm:text-base text-muted-foreground">
          Lütfen daha sonra tekrar deneyin.
        </p>

        {msg ? (
          <div className="mt-6 rounded-2xl border border-border/60 bg-background/40 p-4 sm:p-5 text-left">
            <div className="flex items-start gap-3">
              <div className="mt-0.5 grid size-9 place-items-center rounded-xl bg-primary/10">
                <ShieldAlert className="size-5 text-primary" />
              </div>
              <div className="min-w-0">
                <div className="text-sm font-medium">Bakım Mesajı</div>
                <div className="mt-1 text-sm text-muted-foreground whitespace-pre-wrap break-words">
                  {msg}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};
